import { InputWithLabel } from '@adotel/components'
import { Button, Typography, useMediaQuery, useTheme } from '@material-ui/core'
import RightIcon from '@material-ui/icons/ArrowRightAlt'
import { Skeleton } from '@material-ui/lab'
import React, { useEffect, useState } from 'react'

import { getTranslate, lang } from '../../localization'
import {
  RatePlanForChannelMappingWithRatePlanInput,
  RatePlanForChannelapping,
  RoomTypeForChannelMapping
} from '../../types/channelMapping'
import useStyles from './styles/RoomTypeItemBox.styles'

interface RoomTypeItemBoxProps {
  data: RoomTypeForChannelMapping
  EditModal?: any
  disableRatePlan?: boolean
  onChange?: (event: React.FormEvent<HTMLInputElement>) => void
  onRatePlansChange?: (
    AdotelCode: string,
    rateplans: RatePlanForChannelapping[],
    updatedRateplans: RatePlanForChannelMappingWithRatePlanInput[]
  ) => void
  onChangePMSCodeInput?: (AdotelCode: string, newChannelCode: string) => void
  haveSuppurtRatePlans: boolean
  loading?: boolean
}

const RoomTypeItemBox: React.FC<RoomTypeItemBoxProps> = ({
  data,
  EditModal,
  disableRatePlan,
  onChange,
  onRatePlansChange,
  onChangePMSCodeInput,
  haveSuppurtRatePlans,
  loading
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [rateplans, setRateplans] = useState<RatePlanForChannelapping[]>(
    data.RatePlans
  )
  const [changedData, setChangedData] = useState<
    RatePlanForChannelMappingWithRatePlanInput[]
  >([])
  // write this state(inputValue) to track change of mapped code values
  const [inputValue, setInputValue] = useState<RoomTypeForChannelMapping>(data)

  useEffect(() => {
    setRateplans(data.RatePlans)
    setInputValue(data)
  }, [data, haveSuppurtRatePlans])

  const onClick = () => {
    setIsOpen(true)
  }

  const Icon = () => {
    if (useMediaQuery(theme.breakpoints.up('sm'))) {
      return (
        <div className={lang === 'en' ? '' : classes.LeftIcon}>
          <RightIcon />
        </div>
      )
    } else return null
  }

  return (
    <div>
      <div className={classes.itemBox}>
        {loading ? (
          <Typography variant="h4" className={classes.title}>
            <Skeleton animation="wave" className={classes.skeletonName} />
          </Typography>
        ) : (
          <Typography variant="h4" className={classes.title}>
            {inputValue.AdotelName}
          </Typography>
        )}
        <div className={classes.codeMappingContianer}>
          <div>
            <InputWithLabel
              noHelperText
              label={getTranslate('Adotel Code')}
              viewMode
              value={inputValue.AdotelCode}
              inputSize="small"
            />
          </div>
          <div className={classes.button}>
            {!disableRatePlan && (
              <Button
                variant="contained"
                onClick={onClick}
                size="small"
                className={classes.btn}
                fullWidth>
                <Typography>{getTranslate('RatePlans')}</Typography>
              </Button>
            )}
          </div>
          <div className={classes.iconContainer}>
            <Icon />
          </div>
          <div>
            <InputWithLabel
              value={inputValue.ChannelCode}
              noHelperText
              label={getTranslate('Channel Code')}
              inputSize="small"
              onChange={(event) => {
                onChangePMSCodeInput?.(
                  inputValue.AdotelCode,
                  event.currentTarget.value
                )
                setInputValue({
                  ...inputValue,
                  ChannelCode: event.currentTarget.value
                })
                onChange?.(event)
              }}
            />
          </div>
        </div>
      </div>
      {isOpen && (
        <EditModal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          data={rateplans}
          setData={setRateplans}
          allRatePlans={inputValue.RatePlans}
          onRatePlansChange={onRatePlansChange}
          adotelCodeForRoomtype={inputValue.AdotelCode}
          changedData={changedData}
          setChangedData={setChangedData}
        />
      )}
    </div>
  )
}

export default RoomTypeItemBox
